var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "1180px",
        top: "5vh",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "custom-class": "sk-dialog kids-lifecycle-dialog",
      },
    },
    [
      _c("div", { staticClass: "sk-dialog-content" }, [
        _c(
          "div",
          { staticClass: "sk-panel" },
          [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c(
                "div",
                {
                  staticClass: "sk-panel-icon",
                  staticStyle: {
                    background: "linear-gradient(135deg, #60a5fa, #2563eb)",
                  },
                },
                [_c("i", { staticClass: "el-icon-time" })]
              ),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v("Lịch sử chuyển đổi của học sinh"),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v(
                    "\n            Mã học sinh: " +
                      _vm._s(
                        _vm.kid && _vm.kid.kidCode ? _vm.kid.kidCode : "-"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "lifecycle-dialog-filters" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "lifecycle-dialog-filter-event",
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: "Lọc theo sự kiện",
                    },
                    on: { change: _vm.handleFilterChange },
                    model: {
                      value: _vm.dataSearch.eventType,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "eventType", $$v)
                      },
                      expression: "dataSearch.eventType",
                    },
                  },
                  _vm._l(_vm.eventTypeList, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("el-date-picker", {
                  staticClass: "lifecycle-dialog-filter-date",
                  attrs: {
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "dd-MM-yyyy",
                    clearable: "",
                    placeholder: "Từ ngày",
                  },
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.dataSearch.fromDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "fromDate", $$v)
                    },
                    expression: "dataSearch.fromDate",
                  },
                }),
                _c("el-date-picker", {
                  staticClass: "lifecycle-dialog-filter-date",
                  attrs: {
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "dd-MM-yyyy",
                    clearable: "",
                    placeholder: "Đến ngày",
                  },
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.dataSearch.toDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "toDate", $$v)
                    },
                    expression: "dataSearch.toDate",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "lifecycle-dialog-filter-reset",
                    attrs: { plain: "", icon: "el-icon-refresh" },
                    on: { click: _vm.resetFilters },
                  },
                  [_vm._v("Đặt lại")]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "sk-table lifecycle-dialog-table",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.eventList,
                  border: "",
                  stripe: "",
                  "max-height": "480",
                  "empty-text": "Chưa có lịch sử chuyển đổi",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "Từ ngày", width: "110", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.formatDate(
                                  row.startDate || row.effectiveDate
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Đến ngày", width: "110", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatEndDate(row.endDate)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Sự kiện", width: "155", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.eventTagType(row.eventType),
                                size: "small",
                                effect: "light",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.eventLabel(row.eventType)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Nội dung thay đổi",
                    "min-width": "300",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.eventDescription(row)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Người thao tác",
                    "min-width": "145",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                row.modifiedByName ||
                                  row.lastModifieBy ||
                                  "Không xác định"
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Thời gian thao tác",
                    width: "160",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.formatDateTime(
                                  row.lastModifieDate ||
                                    row.effectiveAt ||
                                    row.createdDate
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "lifecycle-dialog-pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.pageNumber,
                    "page-sizes": _vm.$pageListDefaultNew,
                    "page-size": _vm.maxPageItem,
                    total: _vm.total,
                    layout: "total, sizes, prev, pager, next",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handlePageChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer sk-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }